<template>
  <div ref="menu">
    <slot>
      <div>
        <slot name="label" v-bind="{ toggle, isOpen }" />
      </div>
      <div v-if="isOpen" class="absolute z-50">
        <slot name="menu-content" v-bind="{ toggle, close }" />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { onClickOutside } from '@vueuse/core'

const menuRef = useTemplateRef<HTMLElement>('menu')

const isOpen = ref(false)

const close = () => (isOpen.value = false)
const toggle = () => (isOpen.value = !isOpen.value)

onClickOutside(menuRef, close)
</script>
